import colors from '../foundations/colors';

const Tab = {
   parts: ['tab'],
   variants: {
      line: {
         tab: {
            borderColor: colors.gray[200],
            borderRadius: '0',
            color: colors.gray[500],
            fontWeight: 'bold',
         },
      },
   },
};

export default Tab;
